import Marionette from "backbone.marionette";

export default Backbone.Model.extend({
    urlRoot: function() {
        return "api/goods/index.php";
    },
    /* validate: function(attributes){
        if ( !attributes.areaFuncional ){
            return 'Campo requerido';
        }
    },
    work: function(){
        return this.get('areaFuncional') + ' is working.';
    } */
});


//////////////////
// WEBPACK FOOTER
// ./app/models/goodModel.js
// module id = 15
// module chunks = 0